import {StyleSheet, Text, View} from 'react-native';
import React, {useEffect, useRef} from 'react';
import {ZoomMtg} from '@zoom/meetingsdk';//old - 3.13.2 //new - 5.1.2
// import {KJUR} from 'jsrsasign'; //    "jsrsasign": "11.1.0"
import ENV from '../../../../../environment';
import CCText from '@/Atoms/CCText';
import {FontSizes} from '@/Utils/Dimensions';
import CCColors from '@/Utils/CCColors';

const {ZOOM_IFRAME_BASE_EXIT_URL, ZOOM_CLIENT_ID} = ENV;
// const {ZOOM_CLIENT_ID} = ENV;

const ZoomMeeting = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const meetingEnded = urlParams.get('meetingEnded') === 'true' || false;
  const meetingId = urlParams.get('meetingId') || '';
  const pwd = urlParams.get('pwd') || '';
  const tk = urlParams.get('tk') || '';
  const signature = urlParams.get('signature') || '';
  const userName = urlParams.get('userName') || '';
  const userEmail = urlParams.get('userEmail') || '';

  const sdkKey = ZOOM_CLIENT_ID;

  // CC - Dev;
  // const sdkKey = 'vQmoHYNFQY6RzjczanVLFA';
  // const sdkSecret = 'mXJcJZaM46aPozHsaZX4T2RrnfImezd1';
  // const meetingNumber = '95689689141';
  // const passWord = '731677';
  // const meetingNumber = '98966376812';
  // const passWord = '150349';

  // local;
  // const sdkKey = 'hfDhPycTnanCyDQQkn8qw';
  // const sdkSecret = '10okVOlRMwajMMWnU6JJbSURpTSQ3P5o';
  // const meetingNumber = '81868790846';
  // const passWord = 'dpxL4f';
  // const passWord = 'd3RBAn';
  // const meetingNumber = '89096301876';

  // const role = 1;
  const zakToken = '';
  // const leaveUrl = `${ZOOM_IFRAME_BASE_EXIT_URL}/?zoomEmbed=true&meetingEnded=true`;
  // const useremail = 'support@circlechess.com';

  const zoomRootRef = useRef<HTMLDivElement>(null);

  // const generateZoomToken = () => {
  //   if (!sdkKey || !sdkSecret) {
  //     throw new Error('Missing Zoom SDK key or secret in ENV');
  //   }

  //   const iat = Math.floor(Date.now() / 1000);
  //   const exp = iat + 60 * 60; //*24;

  //   console.log('iat', iat);

  //   const header = {alg: 'HS256', typ: 'JWT'};
  //   const payload = {
  //     sdkKey,
  //     mn: meetingNumber, // meetingId, //
  //     role,
  //     iat,
  //     exp,
  //     appKey: sdkKey,
  //     tokenExp: exp,
  //   };

  //   const sHeader = JSON.stringify(header);
  //   const sPayload = JSON.stringify(payload);

  //   const Fendsignature = KJUR.jws.JWS.sign(
  //     'HS256',
  //     sHeader,
  //     sPayload,
  //     sdkSecret,
  //   );

  //   console.log('Fend Sign', Fendsignature, 'Backend', signature);
  //   // userEmail = 'support@circlechess.com';
  //   if (Fendsignature) startMeeting(Fendsignature);
  // };

  function startMeeting(signature: string) {
    if (zoomRootRef.current) {
      zoomRootRef.current.style.display = 'block';
    }
    // const ZOOM_IFRAME_BASE_EXIT_URL =
    //   window.location.origin || 'https://learn.circlechess.com';
    const leaveUrl = `${ZOOM_IFRAME_BASE_EXIT_URL}/?zoomEmbed=true&meetingEnded=true`;
    ZoomMtg.init({
      debug: false,
      leaveUrl: leaveUrl,
      patchJsMedia: true,
      leaveOnPageUnload: true,
      disablePreview: false,
      defaultView: 'gallery',
      showMeetingHeader: false, //doesnt work
      disableZoomLogo: true,
      meetingInfo: ['topic', 'host'],
      videoDrag: false,
      enableWaitingRoomPreview: true,
      enableHD: true,
      enableFullHD: true,
      disablePictureInPicture: true,
      success: (success: unknown) => {
        console.log(success);
        ZoomMtg.join({
          signature: signature,
          sdkKey: sdkKey,
          meetingNumber: meetingId, //meetingNumber, // meetingId, //
          passWord: pwd, //passWord, //pwd, //
          userName: userName,
          userEmail: userEmail, //useremail, //userEmail,
          tk: tk,
          zak: zakToken,
          success: (success: unknown) => {
            console.log(success);
          },
          error: (error: unknown) => {
            console.log(error);
          },
        });
      },
      error: (error: unknown) => {
        console.log(error);
      },
    });
  }

  useEffect(() => {
    ZoomMtg.preLoadWasm();
    ZoomMtg.prepareWebSDK();
    // generateZoomToken();
    if (signature && signature !== '') {
      startMeeting(signature);
    }
    console.log('Generating Token and Starting');
    if (
      meetingEnded &&
      meetingEnded === true &&
      localStorage.getItem('meetingStarted')
    ) {
      localStorage.removeItem('meetingStarted');
    } else {
      localStorage.setItem('meetingStarted', meetingId);
    }

    // ─── Watermark Hider ────────────────────────────────────────────────────────
    const styleId = 'zoom-v5-watermark-hider';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.innerHTML = `
        /* Force hide the Zoom 5.1+ undocumented SDK Version Watermark */
        .zmu-meeting-info, 
        .send-video-container__indicator-wrapper,
        span.debug-info,
        .debug-info {
          display: none !important;
          opacity: 0 !important;
          visibility: hidden !important;
          width: 0 !important;
          height: 0 !important;
          font-size: 0 !important;
          z-index: -9999 !important;
        }
        /* Also hide any absolute positioned elements in the very top left containing text */
        div[style*="position: absolute"][style*="top: 0"][style*="left: 0"] > span {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }

    const watermarkInterval = setInterval(() => {
      const debugSpans = document.querySelectorAll(
        '.debug-info, span.debug-info',
      );
      debugSpans.forEach(el => {
        if (el instanceof HTMLElement) {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('opacity', '0', 'important');
        }
      });
    }, 1000);

    // ─── Auto Join ──────────────────────────────────────────────────────────────
    let hasAttemptedJoin = false;
    let autoJoinInterval: NodeJS.Timeout | null = null;

    const tryAutoJoin = () => {
      if (hasAttemptedJoin) return;

      // Zoom 5.x renders everything inside #zmmtg-root as regular DOM (no Shadow DOM)
      const root = document.getElementById('zmmtg-root');
      if (!root) return;

      const selectors = [
        'button.preview-join-button',
        '[class*="preview-join"]',
        '.join-audio-by-voip__join-btn',
        '.zm-btn-legacy.join-audio-by-voip__join-btn',
      ];

      for (const selector of selectors) {
        const btn = root.querySelector(selector) as HTMLButtonElement | null;
        if (btn && btn.offsetParent !== null) {
          console.log(`Auto Join: clicking via selector — "${selector}"`);
          btn.click();
          hasAttemptedJoin = true;
          if (autoJoinInterval) clearInterval(autoJoinInterval);
          return;
        }
      }

      // Fallback: find any visible button with join-related text
      const allButtons = root.querySelectorAll('button');
      for (const btn of Array.from(allButtons)) {
        const text = btn.textContent?.trim().toLowerCase() ?? '';
        const isVisible = btn.offsetParent !== null;
        if (
          isVisible &&
          (text === 'join' ||
            text === 'join audio' ||
            text === 'join with computer audio')
        ) {
          console.log(
            `Auto Join: clicking via text match — "${btn.textContent?.trim()}"`,
          );
          btn.click();
          hasAttemptedJoin = true;
          if (autoJoinInterval) clearInterval(autoJoinInterval);
          return;
        }
      }
    };

    // Delay polling by 3s to give Zoom SDK time to render the preview screen
    const delayTimer = setTimeout(() => {
      autoJoinInterval = setInterval(() => {
        tryAutoJoin();
        if (hasAttemptedJoin && autoJoinInterval) {
          clearInterval(autoJoinInterval);
        }
      }, 800);
    }, 10000);

    return () => {
      clearTimeout(delayTimer);
      clearInterval(watermarkInterval);
      if (autoJoinInterval) clearInterval(autoJoinInterval);
    };
  }, []);

  return (
    <View style={styles.container}>
      {meetingEnded ? (
        <CCText color={CCColors.Primary.Dark} fontSize={FontSizes[24]}>
          The Class is over
        </CCText>
      ) : (
        <div id="zmmtg-root" ref={zoomRootRef}></div>
      )}
      {/* <View style={styles.overlay} /> */}
    </View>
  );
};

export default ZoomMeeting;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  // overlay: {
  //   position: 'absolute',
  //   top: 0,
  //   left: 0,
  //   width: '100%',
  //   height: 50,
  //   zIndex: 9999,
  //   backgroundColor: 'transparent',
  //   pointerEvents: 'auto',
  // },
});
